/**
 * @file
 * Behaviors for Logo Sliders.
 */
/* eslint-disable max-len */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Logo Slider behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.logoSlider = {
    attach: function(context) {
      // Abort immediately if the user doesn't want motion.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const $logoSliders = $('.logo-slider', context);

      $logoSliders.each((i, el) => {
        const $logoSlider = $(el);
        $('.logo-slider__list', $logoSlider)
          .not('.slick-initialized')
          .addClass('logo-slider__slick')
          .removeClass('logo-slider__list--no-slick')
          .on('init', () => {
            $('.slick-autoplay-toggle-button', $logoSlider).append(
              '<div class="logo-slider__button-ring"></div>'
            );
          })
          .slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 7000,
            responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  autoplay: true,
                  arrows: false
                }
              },
              {
                breakpoint: 543,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: false,
                  arrows: true,
                  arrowsPlacement: 'beforeSlides'
                }
              }
            ]
          });

        const $playPauseButton = $(
          '.slick-autoplay-toggle-button',
          $logoSlider
        );

        // Pause the slider until it scrolls onto the screen.
        //
        // Synthesizing a click instead of sending a Slick event, since
        // the Slick event fails to toggle the play/pause icon properly.
        $playPauseButton.trigger('click');

        // Detect when the slider (actually, the play/pause button)
        // is on screen.
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              $playPauseButton.trigger('click');

              observer.disconnect();
            }
          });
        });

        observer.observe($playPauseButton.get(0));
      });
    }
  };
})(document, Drupal, jQuery);
